/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomoffdescription3Inputs */

const en_liveroomoffdescription3 = /** @type {(inputs: Liveroomoffdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without the Live Room there is no check-in code and no flyer. You can turn it on in the event’s features.`)
};

const de_liveroomoffdescription3 = /** @type {(inputs: Liveroomoffdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Live Room gibt es keinen Check-in-Code und keinen Flyer. Du kannst ihn in den Funktionen des Events einschalten.`)
};

/**
* | output |
* | --- |
* | "Without the Live Room there is no check-in code and no flyer. You can turn it on in the event’s features." |
*
* @param {Liveroomoffdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomoffdescription3 = /** @type {((inputs?: Liveroomoffdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomoffdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomoffdescription3(inputs)
	return de_liveroomoffdescription3(inputs)
});
export { liveroomoffdescription3 as "liveRoomOffDescription" }